import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import 'font-awesome/scss/font-awesome.scss';
import '../theme/index.css';

import axios from './server/axios.js';
import '../theme.css';
import 'es6-promise/auto';

// import VueRouter from 'vue-router';

import App from './App.vue';
import store from './store/index.js';
import router from './router/index.js';

Vue.config.productionTip = true;

Vue.use(ElementUI);
Vue.prototype.$axios = axios;
Vue.prototype.$store = store;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) { // 需要权限,进一步进行判断
    const myUserInfo = sessionStorage.getItem("userInfo");
    if (myUserInfo) { // 通过vuex state获取当前的token是否存在
      store.commit('updateUserInfo', JSON.parse(myUserInfo));
      next();
    } else if(to.path!=="/home"){ //如果没有权限,重定向到首页
      next({
        path: '/home'
      })
    }else{
      next();
    }
  } else { //不需要权限 直接跳转
    next();
  }
})